import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../redux'
import ivyLeagueSlice from '../../../redux/slice/ivyLeague.slice'
import appSlice from '../../../redux/slice/app.slice'
import axios from 'axios'
import { config } from '../../../config'
import { calculateIvyLeagueTotalsFromAdminConfiguration, getIvyLeagueHybridValidationErrors } from '../../../helpers/ivyLeague/helpers'

const IVY_LEAGUE_WEBSITE_URL = 'https://www.ivyleaguekids.com/contactus.html'
const IVY_LEAGUE_ENROLLMENT_URL = 'https://ivyleague.campmanagement.com/p/campers/login_m.php'

export const Footer = () => {
  const dispatch: AppDispatch = useDispatch()
  const { step, kids, familyInfo, adminConfiguration } = useSelector(
    (state: RootState) => state.ivyLeague
  )

  const returnToWebsite = () => {
    window.location.assign(IVY_LEAGUE_WEBSITE_URL)
  }

  const enrollNow = () => {
    window.location.assign(IVY_LEAGUE_ENROLLMENT_URL)
  }

  const isStepOneValid = (): boolean =>
    kids.length > 0 &&
    familyInfo.firstName.length > 0 &&
    familyInfo.lastName.length > 0 &&
    familyInfo.email.length > 0

  const isStepTwoValid = (): boolean =>
    kids.length > 0 &&
    kids.every(
      (c) =>
        c.grade &&
        c.programs.length > 0 &&
        c.programs.every((p) => p.weekCount > 0 && p.programType.length > 0 && p.programName.length > 0) &&
        getIvyLeagueHybridValidationErrors(c.grade, c.programs ?? []).length === 0
    )

  const isStepThreeValid = (): boolean =>
    familyInfo.firstName.length > 0 &&
    familyInfo.lastName.length > 0 &&
    familyInfo.email.length > 0

  const isStepValid = () => {
    if (step === 1) return isStepOneValid()
    if (step === 2) return isStepTwoValid()
    if (step === 3) return isStepThreeValid()
    if (step === 4) return true
    return false
  }

  const nextClickHandler = () => {
    if (step === 1 && isStepOneValid()) {
      dispatch(ivyLeagueSlice.actions.setStepNumber(step + 1))
    } else if (step === 2 && isStepTwoValid()) {
      dispatch(ivyLeagueSlice.actions.setStepNumber(step + 1))
    } else if (step === 3 && isStepThreeValid()) {
      const { familyBreakdown } = calculateIvyLeagueTotalsFromAdminConfiguration(kids, familyInfo, adminConfiguration)
      const payload = {
        firstName: familyInfo.firstName,
        lastName: familyInfo.lastName,
        email: familyInfo.email,
        phoneNumber: familyInfo.phone ?? '',
        numberOfChildren: kids.length,
        children: kids.map((k) => {
          const totalWeeks = (k.programs ?? []).reduce((s, p) => s + (p.weekCount ?? 0), 0)
          const weeksOnCampus = (k.programs ?? []).filter((p) => p.programType === 'OnCampus').reduce((s, p) => s + (p.weekCount ?? 0), 0)
          const weeksOffCampus = (k.programs ?? []).filter((p) => p.programType === 'OffCampus').reduce((s, p) => s + (p.weekCount ?? 0), 0)
          return {
            childId: k.id,
            grade: k.grade,
            programKey: (k.programs ?? []).map((p) => `${p.programType}:${p.programName}`).join(' | '),
            weeksTotal: totalWeeks,
            weeksOnCampus,
            weeksOffCampus,
            transportMode: k.transportMode ?? 'Parent',
            finaleTrip: k.finaleTrip ?? false,
            usesExtendedHours: k.usesExtendedHours ?? false,
            programs: k.programs ?? []
          }
        }),
        grandTotal: familyBreakdown.finalAmountDue,
        paymentDiscountType: familyInfo.paymentDiscountType,
        paymentMethod: familyInfo.paymentMethod
      }
      dispatch(appSlice.actions.setLoading(true))
      axios({
        method: 'POST',
        url: config.ivyLeagueWorkflowURL,
        headers: { 'Cache-Control': 'no-cache' },
        data: payload
      })
        .then((res) => console.log(res))
        .catch((err) => console.error(err))
        .finally(() => {
          dispatch(appSlice.actions.setLoading(false))
          dispatch(ivyLeagueSlice.actions.setStepNumber(step + 1))
        })
    }
  }

  return (
    <div className="footerContainer">
      <div className="buttonContainer">
        {step > 1 && (
          <button
            className="back"
            style={{ border: '1px solid #096839', color: '#096839' }}
            onClick={() => dispatch(ivyLeagueSlice.actions.setStepNumber(step - 1))}
          >
            Previous
          </button>
        )}
        {step === 4 && (
          <>
            <button
              type="button"
              className="returnToWebsite"
              style={{ backgroundColor: '#096839' }}
              onClick={returnToWebsite}
            >
              Return to website
            </button>
            <button
              type="button"
              className="returnToWebsite"
              style={{ backgroundColor: '#096839' }}
              onClick={enrollNow}
            >
              Enroll Now
            </button>
          </>

        )}
        <button
          className={`next ${step >= 4 ? 'hide' : ''}`}
          disabled={!isStepValid() || step === 4}
          onClick={nextClickHandler}
          style={{ backgroundColor: '#096839' }}
        >
          Next
        </button>
      </div>
    </div>
  )
}
